import { render, staticRenderFns } from "./FileTransfer.vue?vue&type=template&id=549973f1&"
import script from "./FileTransfer.vue?vue&type=script&lang=js&"
export * from "./FileTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports